var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('textarea',_vm._g(_vm._b({directives:[{name:"model",rawName:"v-model",value:(_vm.textareaVal),expression:"textareaVal"}],ref:"textarea",class:[
		_vm.$s.Textarea,
		_vm.$s[("variant_" + _vm.variant)],
		( _obj = {}, _obj[_vm.$s.resizable] = _vm.resizable, _obj ) ],domProps:{"value":(_vm.textareaVal)},on:{"input":function($event){if($event.target.composing){ return; }_vm.textareaVal=$event.target.value}}},'textarea',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }